import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

const ExportButton = ({ onClick }) => (
    <Button variant="light" onClick={onClick} title="Exportar para Excel" aria-label="Exportar para Excel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
            <path d="M256 0a32 32 0 0 1 32 32V320h56.6c14.3 0 21.5 17.3 11.3 27.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96C131.1 337.3 138.3 320 152.6 320H208V32a32 32 0 0 1 32-32h16zm-224 416a32 32 0 0 1 32-32h384a32 32 0 1 1 0 64H64a32 32 0 0 1-32-32z" />
        </svg>
    </Button>
);

ExportButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default ExportButton;
